import { useRef, useState } from "react";
import { GridLayout, HorizontalLayout } from "../layout";
import { QuizStepper } from "../quizStepper";
import { AssessmentFactory } from "../../factory/assessmentContentFactory";
import { Melding } from "../../atoms/melding";
import { VideoPlayerAssessment } from "../../atoms/video";
import { ButtonBar } from "../../molecule/buttonBar";
import { ip } from "../../api/api";

export default function AssessmentPage({elearningInformation, embedStructure, currentAssessment, setEmbedStructure, setCurrentAssessment, setFinished, quizStructure, setQuizStructure, setMaxReachedModule, maxReachedModule, id}) {
    const [message, setMessage] = useState("");
    const [messageAnimation, setMessageAnimation] = useState("");
    const [animationClass, setAnimationClass] = useState("animate-in");
    const [avatarVideoMini, setAvatarVideoMini] = useState(false);
    const answerTextTimer = useRef(null);

    const saveLocalAnswer = (moduleIndex, payload) => {
      const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
      const answers = parsed.answers || {};
      answers[moduleIndex] = payload;
      localStorage.setItem(`embed_${id}`, JSON.stringify({ ...parsed, answers }));
    };

    const submitAnswer = async (answer_content) => {
      try {
        const parsed = JSON.parse(localStorage.getItem(`embed_${id}`) || "{}");
        const authToken = parsed?.token;
        if (!authToken) return;
        const current = embedStructure?.[currentAssessment];
        await fetch(`${ip}/api/embed/${id}/answer`, {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Auth-Token": authToken },
          body: JSON.stringify({
            module_index: currentAssessment,
            id_modules: current?.id_modules,
            quiz_type: current?.module_content?.quiz_type,
            answer_content
          })
        });
      } catch {}
    };

    const clickAnswerHandler = (index) => {
      const copy = [...embedStructure];
      const current = copy[currentAssessment];
      const answers = current?.module_content?.quiz_answers;
      if (!Array.isArray(answers) || answers[index] === undefined) return;
      answers[index].chosen = !answers[index].chosen;
      copy[currentAssessment] = { ...current, module_content: { ...current.module_content, quiz_answers: [...answers] } };
      setEmbedStructure(copy);
      saveLocalAnswer(currentAssessment, { quiz_type: current?.module_content?.quiz_type, answer_content: answers });
      submitAnswer(answers);
    };

    const updateOrderHandler = (value) => {
      const copy = [...embedStructure];
      const current = copy[currentAssessment];
      copy[currentAssessment] = { ...current, module_content: { ...current.module_content, quiz_answers: value } };
      setEmbedStructure(copy);
      saveLocalAnswer(currentAssessment, { quiz_type: current?.module_content?.quiz_type, answer_content: value });
      submitAnswer(value);
    };

    const updateMatchHandler = (value) => {
      saveLocalAnswer(currentAssessment, { quiz_type: embedStructure?.[currentAssessment]?.module_content?.quiz_type, answer_content: value });
      submitAnswer(value);
    };

    const answerTextHandler = (value) => {
      const copy = [...embedStructure];
      const current = copy[currentAssessment];
      const qa = current?.module_content?.quiz_answers || {};
      const updatedQA = { ...(qa || {}), quiz_answer: value };
      copy[currentAssessment] = { ...current, module_content: { ...current.module_content, quiz_answers: updatedQA } };
      setEmbedStructure(copy);
      saveLocalAnswer(currentAssessment, { quiz_type: current?.module_content?.quiz_type, answer_content: value });
      if (answerTextTimer.current) clearTimeout(answerTextTimer.current);
      answerTextTimer.current = setTimeout(() => submitAnswer(value), 400);
    };

    const hasAnswers = (current) => {
      const quizType = Number(current?.module_content?.quiz_type);
      const answers = current?.module_content?.quiz_answers;
      switch (quizType) {
        case 1: case 3: case 5: return Array.isArray(answers) && answers.some(a => a.chosen);
        case 2: case 4: return true;
        case 6: return typeof answers?.quiz_answer === "string" && answers.quiz_answer.trim().length > 0;
        default: return true;
      }
    };


    const goNext = () => {
    const current = embedStructure?.[currentAssessment];
    if (!hasAnswers(current)) {
      setMessage("Je moet een antwoord selecteren voordat je verder kunt gaan.");
      setMessageAnimation("fade-in-bottom-to-top");
      setTimeout(() => { setMessageAnimation("fade-out-top-to-bottom"); setTimeout(() => setMessage(""), 1000); }, 3000);
      return;
    }
    setAnimationClass("animate-out");
    setMessage(""); setMessageAnimation("");
    setTimeout(() => {
      if (currentAssessment < embedStructure.length - 1) setCurrentAssessment(v => v + 1);
      else setFinished(true);
      setAnimationClass("animate-in");
    }, 200);
  };

  const goBack = () => {
    if (currentAssessment > 0) {
      setAnimationClass("animate-out-back");
      setTimeout(() => { setCurrentAssessment(v => v - 1); setAnimationClass("animate-in-back"); setMessage(""); setMessageAnimation(""); }, 200);
    }
  };

  const toggleCollapse = (id) => {
    const copy = [...quizStructure];
    if (copy[id]) copy[id].collapsed = !copy[id].collapsed;
    setQuizStructure(copy);
  };

  const goToSection = (index) => {
    setCurrentAssessment(index);
    setMessage(""); setMessageAnimation("");
  };
  return (
    <div style={{ background: "var(--grey-50)", height: "100vh" }}>
      <div
        style={{ backgroundImage: `url('${elearningInformation.image_url}')` }}
        className="topbar-embed-bg"
      >
        <div className="topbar-embed">{elearningInformation.title}</div>
      </div>
      <div className="container" style={{ margin: "0", height: "calc(100dvh - 12rem)" }}>
        <HorizontalLayout style={{ alignItems: "flex-start" }}>
          <QuizStepper
            setMaxReachedModule={setMaxReachedModule}
            maxReachedModule={maxReachedModule}
            activeSection={currentAssessment}
            quizStructure={quizStructure}
            goToSection={goToSection}
            toggleCollapse={toggleCollapse}
            style={{ overflow: "hidden" }}
          />
          <div
            style={{ width: !avatarVideoMini ? "50%" : "100%" }}
            className={`vertical quiz-comp phone-quiz standard-shadow standard-border quiz-step-wrapper ${animationClass} ${avatarVideoMini ? "" : "big"}`}
            key={currentAssessment}
          >
            <h3 style={{ marginBottom: "1rem" }}>
              {embedStructure[currentAssessment].module_content.quiz_question}
            </h3>
            <br />
            <AssessmentFactory
              module_type={embedStructure[currentAssessment].module_type}
              data={embedStructure[currentAssessment].module_content}
              clickAnswer={clickAnswerHandler}
              updateOrder={updateOrderHandler}
              updateMatch={updateMatchHandler}
              answerText={answerTextHandler}
            />
            <Melding message={message} animationClass={messageAnimation} />
          </div>
          {!avatarVideoMini && (
            <VideoPlayerAssessment
              src={embedStructure[currentAssessment].module_content.video}
              onClick={() => setAvatarVideoMini(!avatarVideoMini)}
              openVideo={!avatarVideoMini}
            />
          )}
        </HorizontalLayout>
      </div>
      {avatarVideoMini && (
        <VideoPlayerAssessment
          src={embedStructure[currentAssessment].module_content.video}
          onClick={() => setAvatarVideoMini(!avatarVideoMini)}
          openVideo={!avatarVideoMini}
        />
      )}
      <GridLayout
        columnsTemplate="1fr auto"
        style={{
          boxShadow: "rgba(0, 0, 0, 0.05) 0px -1px 5px 1px",
          background: "var(--white)",
          position: "fixed",
          bottom: "0px",
          width: "100%",
          padding: "1rem",
          boxSizing: "border-box",
          borderTop: "1px solid rgb(241, 241, 241)",
        }}
      >
        <div />
        <ButtonBar back={goBack} next={goNext} />
      </GridLayout>
    </div>
  );
};